import { Rectangle } from "@mui/icons-material";
import { Chip, Typography } from "@mui/material";
import { JSX } from "react";

export default function Heading({
  icon,
  label,
}: {
  icon: JSX.Element;
  label: string;
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "0.5em",
        marginBottom: "0.5em",
      }}
    >
      <div style={{ width: "100%", height: "1px", backgroundColor: "darkgrey", marginRight:"0.3em" }} />
        {icon}
        <Typography>{label}</Typography>
      <div style={{ width: "100%", height: "1px", backgroundColor: "darkgrey", marginLeft:"0.3em"  }} />
    </div>
  );
}
